import { fill } from 'lodash';
import { pipe, prop } from 'ramda';

const lastTwoDigits = num => `0${num}`.slice(-2);

const detailsToInput = card => ({
  number: `${fill(Array(3), '****').join(' ')} ${card.last4}`,
  cvc: '',
  exp: `${lastTwoDigits(card.exp_month)} / ${lastTwoDigits(card.exp_year)}`,
});

export const transformCardForForm = pipe(
  prop('details'),
  detailsToInput,
);

export const initialDebitCard = { instantPayout: true };
